// extracted by mini-css-extract-plugin
module.exports = {"button":"KioskButton_button__3BqYZ"};